import { graphql } from '@/graphql-setup'

export const ALL_TERMINAL_ENTRIES = graphql(`
  query AllTerminalEntries($user: ID!, $last: Int) {
    allTimeEntries(user: $user, last: $last, fromTerminal: true) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          totalWork
          pause
          overtime
          user {
            id
          }
        }
      }
    }
    me {
      id
      salaryWorkTime(moduleConfigName: "Terminal") {
        id
        name
        dailyWorkLimit
        pauseDuration
      }
    }
  }
`)

export const TODAYS_TERMINAL_ENTRIES = graphql(`
  query TodaysTerminalEntries($user: ID!) {
    todaysTimeEntries(user: $user, fromTerminal: true) {
      edges {
        node {
          id
          datetimeStart
          datetimeEnd
          totalWorkTime
        }
      }
    }
    todaysTimeEntriesTotalWorkTime(onlyTerminal: true)
    isOnTerminalNetwork
    isWorking
  }
`)

export const ALL_TERMINALS = graphql(`
  query AllTerminals {
    allTerminals {
      edges {
        node {
          id
          name
          ip
          ipFilterRange
        }
      }
    }
  }
`)
